<template>
  <svg viewBox="0 0 512 512" style="fill: currentColor; height: 1rem">
    <path
      d="M121 261V421H511V261H121ZM241 311H211V391H191V311H161V291H241V311ZM357.164 379.492L341.978 392.508L311 356.366L280.021 392.508L264.835 379.492L297.829 341L264.836 302.508L280.022 289.492L311 325.634L341.979 289.492L357.165 302.508L324.171 341L357.164 379.492ZM461 311H431V391H411V311H381V291H461V311Z"
      fill="#212529"
    />
    <path d="M301 1H1V461H31V31H301V1Z" fill="#212529" />
    <path
      d="M101 441V421V261V241H121H401V146.858H305.142V51H51V511H401V441H121H101ZM101 86H271V106H101V86ZM101 136H271V156H101V136ZM101 186H351V206H101V186Z"
      fill="#212529"
    />
    <path d="M325.143 51V126.858H401L325.143 51Z" fill="#212529" />
  </svg>
</template>
